var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"skip-navigation"},[_c('a',{ref:"skipLink",staticClass:"skip-link",attrs:{"href":"#main-content"},on:{"click":_vm.skipToMain}},[_vm._v(" "+_vm._s(_vm.$t('accessibility.skipToMainContent'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }